import type { Maybe } from '@tectonics/utils/types';
import { getRatePercentage, truncateDecimal, type FormatDecimal } from './formatting';
import type { Amount } from './amount';

export type FormatTaxPercentage = (percentage: Maybe<string>) => Maybe<string>;

export type TaxRateToPercentageString = (formatDecimal: FormatDecimal) => FormatTaxPercentage;

export const taxRateToPercentageString: TaxRateToPercentageString = (formatDecimal: FormatDecimal) => 
  (percentage: Maybe<string>) => {
    if (percentage === null || percentage === undefined) return null;

    return `${formatDecimal(truncateDecimal(getRatePercentage(percentage)))}`;
  };
  
export function getLocalTaxCodeFromString(searchString: string): string {
  const code = localTaxCodeMap.get(searchString.toLowerCase() as LocalTaxCodeKey);

  if (!code) throw new Error(`PRS/Money: ${searchString} is not related to any local tax code`);
  
  return code;
}

export const localTaxCode = {
  iof: 'BR_IOF',
  br_iof: 'BR_IOF',
  iva: 'AR_IVA',
  ar_iva: 'AR_IVA',
  ar_ip: 'AR_IP',
  ig_ibp: 'AR_IG_IBP',
  ar_ig_ibp: 'AR_IG_IBP',
  ar_non_resident_igbp: 'AR_NON_RESIDENT_IGBP',
  ar_iibb: 'AR_IIBB_',
  py_iva: 'PY_IVA',
  cr_iva: 'CR_IVA',
  sv_itbms: 'SV_ITBMS',
  inr_gst: 'INR_GST',
} as const;

export type LocalTaxCodeKey = keyof typeof localTaxCode;

export type LocalTaxCodeValue = (typeof localTaxCode)[LocalTaxCodeKey];

export const localTaxCodeMap = new Map<LocalTaxCodeKey, LocalTaxCodeValue>(
  Object.entries(localTaxCode) as [LocalTaxCodeKey, LocalTaxCodeValue][]
);export type LocalTax = {
  readonly code: string;
  readonly amount: Amount;
  readonly rate?: string | null;
};

export const ALLOWED_LOCAL_TAX_CODE_SUBSTRINGS = [
  'AR_IIBB_',
] as const;

export type AllowedLocalTaxCodeSubstrings = (typeof ALLOWED_LOCAL_TAX_CODE_SUBSTRINGS)[number];
